<template>

  <div class="row" @mouseover="show=true" @mouseleave="show=false">
      <div class="col-12">
        <flat-pickr v-if="plan_date" :config="options" v-model="selected_task.plan_date" class="form-control form-control-shadow mt-auto date-select form-control-sm " :placeholder="$t('elements.date_select.unplanned')"></flat-pickr>
        <flat-pickr v-else :config="options" v-model="selected_task.deadline_date" class="form-control mt-auto form-control-shadow date-select form-control-sm " :placeholder="$t('elements.date_select.no_deadline')" ></flat-pickr>
<!--        <vue-timepicker></vue-timepicker>-->
        <div :class="[show ? 'show': 'hide']">
          <div v-if="selected_task && (plan_date ? selected_task.plan_date : selected_task.deadline_date)">
            <button @click="unsetDate" class="btn btn-xs text-muted btn-link"><i class="fe fe-x"></i> {{ $t("elements.date_select.unset") }}</button>
            <button v-if="false" @click="unsetDate" class="btn btn-xs text-muted btn-link"><i class="fe fe-clock"></i> {{ $t("elements.date_select.add_time") }}</button>
            <span v-if="plan_date" class="float-right badge mt-1 badge-soft-dark" style=" ">{{ selected_task.plan_date | moment("from") }}</span>
            <span v-else class="float-right badge mt-1 badge-soft-dark" style=" ">{{ $t("elements.date_select.left") }} {{ selected_task.deadline_date | moment("from", true) }}</span>
          </div>
          <div v-else>
            <button @click="setDelta(1)" class="btn btn-xs text-muted btn-link">{{ $t("elements.date_select.tomorrow") }}</button>
            <button @click="setDelta(7)" class="btn btn-xs text-muted btn-link">{{ $t("elements.date_select.in_a_week") }}</button>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import flatPickr from 'vue-flatpickr-component';
  // import VueTimepicker from 'vue2-timepicker';
  import { formatDateMixin } from '@/mixins/formatDateMixin';

  const moment = require('moment');
  export default {
    name: 'DateSelect',
    mixins: [formatDateMixin],
    computed: {
      ...mapGetters([
        'selected_task',
        'account',
      ]),
    },
    props: {
      plan_date: {
        default: false,
      },

    },
    data () {
      return {
        show: false,
        options: {
          mode: 'single',
          altInput: true,
          altFormat: 'F j, Y',
          dateFormat: 'Y-m-d',
          // minDate: "today",
          locale: {
            firstDayOfWeek: 1, // start week on Monday
          },
          // enableTime: true,
        },
      };
    },
    methods: {
      setDelta (delta) {
        if (this.plan_date) {
          this.selected_task.plan_date = this.formatDate(moment().add(delta, 'days'));
        } else {
          this.selected_task.deadline_date = this.formatDate(moment().add(delta, 'days'));
        }
      },
      unsetDate () {
        if (this.plan_date) {
          this.selected_task.plan_date = null;
        } else {
          this.selected_task.deadline_date = null;
        }
      },

    },
    created () {
      // this.enablePickr()

    },
    components: {
      // VueTimepicker,
      flatPickr,
    },
  };
</script>

<style scoped>

  .show {
    opacity: 1;
    -webkit-transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -ms-transition: opacity 0.3s ease-in-out;
    -o-transition: opacity 0.3s ease-in-out;
    transition: opacity 0.3s ease-in-out;
  }

  .hide {
    opacity: 0.2;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }

  .date-select {
    box-shadow: 0.2rem .35rem rgba(110, 110, 110, 0.07) !important;
  }

</style>
